import { render, staticRenderFns } from "./chuanpiao.vue?vue&type=template&id=43f98bf6&scoped=true&"
import script from "./chuanpiao.vue?vue&type=script&lang=js&"
export * from "./chuanpiao.vue?vue&type=script&lang=js&"
import style0 from "./chuanpiao.vue?vue&type=style&index=0&id=43f98bf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f98bf6",
  null
  
)

export default component.exports